import { tsInitVue } from './js-utils'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.ospe-activity-reimbursement-submissions')) {
    const reimbursementSubmissionsGridEl = document.querySelector('div[data-is="OspeActivityReimbursementSubmissionsGrid"]')
    if (reimbursementSubmissionsGridEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const OspeActivityReimbursementSubmissionsGrid = await import('./vue-components/ospe/ospe-activity-reimbursement-submissions-grid.vue')

        window.ospeActivityReimbursementGrid = tsInitVue(OspeActivityReimbursementSubmissionsGrid.default, reimbursementSubmissionsGridEl, {
          listUrl: reimbursementSubmissionsGridEl.dataset.listUrl,
          mode: reimbursementSubmissionsGridEl.dataset.mode,
        })
      })()
    }
  }
})
